import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function ClientLogin() {
  const [clientName, setClientName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    try {
      const data = await api.clientLogin(clientName, password);
      localStorage.setItem('token', data.token);
      localStorage.setItem('role', 'client');
      localStorage.setItem('clientName', data.clientName);
      navigate('/portal');
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>Client Portal</h2>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input value={clientName} onChange={e => setClientName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div style={{ display: 'flex', gap: 6 }}>
              <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} required style={{ flex: 1 }} />
              <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowPassword(p => !p)}>{showPassword ? 'Hide' : 'Show'}</button>
            </div>
          </div>
          <button className="btn btn-primary" style={{ width: '100%' }} type="submit">Sign In</button>
        </form>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <a href="/admin/login" style={{ fontSize: 12, color: '#718096' }}>Admin Login →</a>
        </div>
      </div>
    </div>
  );
}
